var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCheckmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.55 3.165a1 1 0 0 1 .285 1.385l-6.94 10.53a1.5 1.5 0 0 1-2.22.323l-4.32-3.638a1 1 0 1 1 1.29-1.53l3.889 3.276L14.165 3.45a1 1 0 0 1 1.385-.285Z",
  clipRule: "evenodd"
})));
export default SvgIconCheckmark;